import { clientPreferences } from "../Shared/ClientPreferences/clientPreferences";

export const videoBackground = () => {
  const components = document.querySelectorAll("[data-js-background-video]");

  if (!components?.length) {
    return;
  }

  if (clientPreferences.prefersReducedMotion) {
    console.info(
      "Reduce motion preference enabled, skipping autoplaying a video background."
    );
    return;
  }

  for (const component of components) {
    initializeVideoComponent(component);
  }
};

const initializeVideoComponent = (component: Element) => {
  const video = component.querySelector("div[data-vimeo-url]") as HTMLElement;
  const fallbackImage =
    component.querySelector("picture") || component.querySelector("img");

  if (!video) {
    console.error("A background video component is missing a video element.");
    return;
  }

  // Prevent Vimeo from trying to initialize player iframe, as we create it ourselves.
  video.setAttribute("data-vimeo-initialized", "true");

  if (!fallbackImage) {
    console.warn("A background video component is missing a fallback image.");
  }

  const videoSrc = video.getAttribute("data-vimeo-url");
  const videoLabel = video.getAttribute("data-video-label");

  let videoIframe: HTMLIFrameElement | undefined;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        videoIframe = document.createElement("iframe");
        videoIframe.src = videoSrc ?? "";
        videoIframe.ariaLabel = videoLabel ?? "Background video";
        videoIframe.onload = () =>
          setTimeout(() => video.classList.remove("opacity-0"), 1600);

        video.appendChild(videoIframe);

        // Only check if element is in view once.
        // As we have no playback control of the video, we can't pause the video again
        // when the element is out of view.
        observer.disconnect();
      }
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.7,
    }
  );

  observer.observe(video);

  // Having the ability to destroy the video background iframe is useful
  // if we know that the video is not going to show after a specific event,
  // such as opening an inline video on top of it.
  // Instead of pausing (which we can't due to lack of playback control)
  // we can just destroy the iframe.
  const destroyTriggers = document.querySelectorAll(
    `[data-js-video-background-destroy="${videoSrc}"]`
  );

  for (const trigger of destroyTriggers) {
    trigger.addEventListener("click", () => {
      setTimeout(() => videoIframe?.remove(), 600);
    });
  }
};
